import * as React from 'react';
import { Button } from 'antd';
import * as _ from 'lodash';
import './DocumentPagination.less';
import PageNumberControls from './PageNumberControls';

type Props = {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    scale: number;
    onScaleChange: (scale: number) => void;
    defaultScale?: number;
    minScale?: number;
    maxScale?: number;
    className?: string;
};

export const DocumentPagination: React.FC<Props> = ({
    currentPage,
    totalPages,
    onPageChange,
    scale,
    onScaleChange,
    defaultScale = 1,
    minScale = 0.5,
    maxScale = 1.5,
    className = ''
}) => {
    const changeScale = (newScale: number) => {
        const clampedScale = _.clamp(+newScale.toFixed(2), minScale, maxScale);
        onScaleChange(clampedScale);
    };

    const containerClassName = `alpha-pagination-container ${className}`;

    return (
        <div className={containerClassName}>
            <div className="alpha-pagination">
                <PageNumberControls currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />

                <Button
                    size="small"
                    onClick={() => changeScale(scale - 0.1)}
                    type="link"
                    disabled={scale <= minScale}
                    className="zoom-controls"
                >
                    <i className={`alpha-icon sm zoom-out ${scale <= minScale ? 'inactive' : ''}`} />
                </Button>
                <Button size="small" onClick={() => onScaleChange(defaultScale)} type="link" className="zoom-controls">
                    <i className="alpha-icon sm reset-scale" />
                </Button>
                <Button
                    size="small"
                    onClick={() => changeScale(scale + 0.1)}
                    type="link"
                    disabled={scale >= maxScale}
                    className="zoom-controls"
                >
                    <i className={`alpha-icon sm zoom-in ${scale >= maxScale ? 'inactive' : ''}`} />
                </Button>
            </div>
        </div>
    );
};

export default DocumentPagination;
